module.exports = __webpack_public_path__ + "img/Complete_Symbol-512.63c9a41e.png";